import {BaseTOI} from "./BaseTOI";
import {TOInvoiceApproving} from "./TOInvoiceApproving";

export class TOIInvoiceApproving extends BaseTOI {
	// @ts-ignore
	muParent: TOInvoiceApproving;

	beforeIndex() {
		this.container.classList.add("ticket-overview__item", "ticket-overview--invoice-approving__item");
		this.muAppendContent(`
			<div mu-bind="dtCreate:@visible" class="icon-before-email field-created">Přijato: <span mu-bind='dtCreate|dateTime("d.m.Y")'></span></div>
			<a mu-id="link1" mu-bind='evidenceUid;id|prepend("id "):title' class="field-evidenceUid"></a>
			
			<div -mu-bind="buSubjectName:@visible" class="field-buSubject"><span mu-bind='buSubjectName' class="icon-before-building"></span></div>
			<div mu-bind="accountDocumentTypeName:@visible" class="field-accountDocumentTypeName icon-before-color-documents">
				<span class="field-accountDocumentTypeName-before"></span>
				<span mu-bind='accountDocumentTypeName'></span>
				<span mu-bind="stateName"></span>
			</div>
			
			<div mu-bind='summary;summary:@visible' class="icon-before-detail grid-column-s2 field-summary"></div>
			
			<div mu-bind='vendorName;vendorName:@visible' class="icon-before-supplier grid-column-s2 field-vendorName"></div>
			<div mu-bind="amountWT:@visible" class="field-amountWT">S DPH: <span mu-bind='amountWT|price'></span></div>
			<div mu-bind="amountNT:@visible" class="field-amountNT">Bez: <span mu-bind='amountNT|price'></span></div>
			<div mu-bind="dtTax:@visible" class="icon-before-calendar field-dtTax"><DUZP: <span mu-bind='dtTax|dateTime("d.m.Y")'></span></div>
			<div mu-bind="dtDue:@visible" class="icon-before-calendar field-dtDue">Spl.: <span mu-bind='dtDue|dateTime("d.m.Y")'></span></div>
			<div mu-bind="mailFrom:@visible"  class="field-mailFrom">Od: <span mu-bind='mailFrom'></span></div>
			<div class="field-variableSymbol">Vs: <span mu-bind='variableSymbol'></span></div>
		`)
	}

	muBindData(srcData: any) {
		this.srcData = {
			...srcData,
			vendorName: srcData.vendorInfo?.name || "",
			accountDocumentTypeName: srcData.accountDocumentTypeName || "",
			summary: /* srcData.vendorInfo ? "" : */ srcData.summary,
			dtCreate: /*srcData.dtDue ? null :*/ srcData.dtCreate,
			mailFrom: false
		};
		super.muBindData(this.srcData);
		this.muParent.router.prepareAnchor(this.ui.link1 as unknown as HTMLAnchorElement, "ticket", { ticketId: srcData.id })
	}

}